import { render, staticRenderFns } from "./FloorCreate.vue?vue&type=template&id=6988c1d0&scoped=true"
import script from "./FloorCreate.vue?vue&type=script&lang=js"
export * from "./FloorCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6988c1d0",
  null
  
)

export default component.exports